module.exports = __webpack_public_path__ + "img/wzb@3x.db6a8dc3.png";